import { Icon } from './Icon'
import { BrandIfood, Brand99 } from './Brands'
import { linkWhatsApp } from '../config'

type Item = { icone: string; titulo: string; texto: string; destaque?: boolean }
type Coluna = { classe: string; icone: string; titulo: string; atraso?: string; itens: Item[] }

const COLUNAS: Coluna[] = [
  {
    classe: 'ecol ecol--a', icone: 'megaphone', titulo: 'Relacionamento e Vendas',
    itens: [
      { icone: 'megaphone', titulo: 'Disparador de WhatsApp', texto: 'Envie campanhas e promoções para sua base de clientes.' },
      { icone: 'gear', titulo: 'Automações de WhatsApp', texto: 'Automatize o atendimento e reduza tarefas repetitivas.' },
      { icone: 'star', titulo: 'Programa de Fidelidade', texto: 'Crie benefícios para estimular novas compras.' },
      { icone: 'users', titulo: 'CRM de Clientes', texto: 'Organize informações e histórico dos seus clientes.' },
      { icone: 'chat', titulo: 'Sistema de Avaliações', texto: 'Colete a opinião dos clientes e identifique melhorias.' },
      { icone: 'ticket', titulo: 'Cupons e Descontos', texto: 'Crie campanhas promocionais com cupons.' },
      { icone: 'money', titulo: 'Cashback', texto: 'Permita que parte do valor retorne em compras futuras.' },
    ],
  },
  {
    classe: 'ecol ecol--b', icone: 'book', titulo: 'Cardápio e Atendimento', atraso: '90',
    itens: [
      { icone: 'book', titulo: 'Cardápio Digital', texto: 'Tenha um canal próprio para apresentar seus produtos.' },
      { icone: 'wa', titulo: 'Cardápio via WhatsApp', texto: 'Seu cardápio direto no WhatsApp.' },
      { icone: 'table', titulo: 'Cardápio para Mesas', texto: 'O cliente acessa pelo celular no salão.' },
      { icone: 'counter', titulo: 'Cardápio para Balcão', texto: 'Organize o atendimento no estabelecimento.' },
      { icone: 'robot', titulo: 'Chatbot / Robô de WhatsApp', texto: 'Automatiza respostas e orienta o cliente.' },
      { icone: 'calendar', titulo: 'Agendamento de Pedidos', texto: 'Permite pedido para data e horário futuro.' },
      { icone: 'kiosk', titulo: 'Totem de Autoatendimento', texto: 'O cliente realiza o pedido diretamente no terminal.' },
    ],
  },
  {
    classe: 'ecol ecol--c', icone: 'chart', titulo: 'Operação e Gestão', atraso: '180',
    itens: [
      { icone: 'box', titulo: 'Controle de Estoque', texto: 'Registre entradas, saídas e necessidade de reposição.' },
      { icone: 'truck', titulo: 'Roteirização de Entregas', texto: 'Auxilia na organização das rotas de entrega.' },
      { icone: 'table', titulo: 'Gestão de Mesas e Comandas', texto: 'Centraliza pedidos e consumo de mesas.' },
      { icone: 'monitor', titulo: 'Módulo KDS', texto: 'Exibe os pedidos para a cozinha em tempo real.' },
      { icone: 'money', titulo: 'Controle Financeiro', texto: 'Acompanhe receitas, despesas e desempenho.' },
      { icone: 'doc', titulo: 'Ficha Técnica de Preparo', texto: 'Padronize receitas, insumos, quantidades, fator de cocção e rendimento. Tenha mais controle sobre o custo do prato.', destaque: true },
      { icone: 'chart', titulo: 'Relatórios e Indicadores', texto: 'Acompanhe o desempenho do seu negócio.' },
    ],
  },
]

const CONECTADO = ['Centralização de informações', 'Menos retrabalho', 'Mais organização', 'Mais eficiência operacional']

export function Eco() {
  return (
    <section className="eco" id="ecossistema">
      <div className="shell">
        <div className="eco__head">
          <div>
            <p className="eyebrow eyebrow--dark" data-reveal="up"><i />Nossos produtos</p>
            <h2 className="h2" data-reveal="mask">
              Mais do que estruturação.<br />
              Um ecossistema para o <span className="accent">crescimento do seu delivery.</span>
            </h2>
            <p className="eco__lead" data-reveal="up" data-delay="140">
              Ferramentas e soluções desenvolvidas para ajudar restaurantes a vender melhor,
              organizar a operação e fortalecer o relacionamento com os clientes.
            </p>
          </div>
          <span className="script script--4" data-reveal="up" data-delay="220">
            Tudo o que<br />o seu restaurante<br />precisa, em um só lugar.
          </span>
        </div>

        <div className="eco__grid">
          {COLUNAS.map((col) => (
            <section className={col.classe} data-reveal="up" data-delay={col.atraso} key={col.titulo}>
              <h3><span className="ecol__ico"><Icon name={col.icone} /></span>{col.titulo}</h3>
              <ul>
                {col.itens.map((item) => (
                  <li className={item.destaque ? 'is-featured' : undefined} key={item.titulo}>
                    <span><Icon name={item.icone} /></span>
                    <b>{item.titulo}{item.destaque && <> <em>Destaque</em></>}</b>
                    <small>{item.texto}</small>
                  </li>
                ))}
              </ul>
            </section>
          ))}

          <aside className="eco__connected" data-reveal="up" data-delay="270">
            <h3>Tudo<br />conectado.</h3>
            <p>iFood, 99 Food, WhatsApp, Cardápio Digital e ferramentas de gestão integrados para simplificar sua operação.</p>
            <div className="eco__logos">
              <span className="elogo elogo--ifood has-logo"><BrandIfood md /></span>
              <span className="elogo elogo--99 has-logo"><Brand99 md /></span>
              <span className="elogo elogo--wa"><Icon name="wa" /></span>
              <span className="elogo elogo--qr"><Icon name="qr" /></span>
            </div>
            <ul className="checks checks--light">
              {CONECTADO.map((c) => <li key={c}>{c}</li>)}
            </ul>
            <a href={linkWhatsApp()} className="btn btn--primary btn--block">
              Quero conhecer a plataforma <span className="arw">&rarr;</span>
            </a>
          </aside>
        </div>
      </div>
    </section>
  )
}
